<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="formData.shipPlanRange == 'A' ? 24 : 16">
        <div class="d-flex mb-1" style="font-size: 14px; color: #606266">
          <div
            class="side-frame-success"
            style="height: inherit;margin: 0;min-height: 21px;"
          ></div>
          <div>
            <span v-if="amzPeriodTitle">
              {{
                copyAmzPeriodTitle == amzPeriodTitle
                  ? this.formData.amzPeriodTitle
                  : amzPeriodTitle
              }}
            </span>
            <el-divider v-if="amzPeriodTitle" direction="vertical"></el-divider>
            <el-tag
              size="small"
              :type="
                formData.amzPeriodStatus === 'Y'
                  ? 'success'
                  : formData.amzPeriodStatus === 'D'
                  ? 'danger'
                  : ''
              "
            >
              {{ formData.v_amzPeriodStatus || 'New' }}
            </el-tag>
            <el-divider
              v-if="formData.modifyByName"
              direction="vertical"
            ></el-divider>
            <span v-if="formData.modifyByName">
              Update：{{ formData.modifyByName || '--' }} at
              {{ formData.modifyDate || '--' }}
            </span>
          </div>
        </div>

        <el-form
          ref="form"
          size="small"
          :model="formData"
          :rules="rules"
          :disabled="disabled"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_planNo') || '补货计划编号'"
                prop="planNo"
              >
                <el-input
                  v-model="formData.planNo"
                  :placeholder="$l('INDEX.tips_input_placeholder')"
                  clearable
                  maxlength="50"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_amazonStoreRegion') || '店铺区域'"
                prop="amazonStoreRegion"
              >
                <dict-select
                  v-model="formData.amazonStoreRegion"
                  url="/ecom/amz/market/dictSelect"
                  :selectedLabel.sync="formData.v_amazonStoreRegion"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  :disabled="isChange"
                  filterable
                  size="small"
                  style="width:100%"
                  @change="changeStore"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_skuSalesChannel') || '产品售卖渠道'"
                prop="skuSalesChannel"
              >
                <dict-select
                  v-model="formData.skuSalesChannel"
                  url="/sys/common/dict/system"
                  :body="{ dictType: 'skuSalesChannel' }"
                  :selectedLabel.sync="formData.v_skuSalesChannel"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  clearable
                  filterable
                  :disabled="isChange"
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_labelingType') || '贴标方式'"
                prop="labelingType"
              >
                <dict-select
                  v-model="formData.labelingType"
                  :selectedLabel.sync="formData.v_labelingType"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'labelingType' }"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  clearable
                  filterable
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_shippingDate') || '预计发运日期'"
                prop="shippingDate"
              >
                <el-date-picker
                  v-model="formData.shippingDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                  :picker-options="shippingDateOptions"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_etaDate') || '预计到货日期'"
                prop="etaDate"
              >
                <el-date-picker
                  v-model="formData.etaDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                  :picker-options="etaDateOptions"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_planType') || '发运类型'"
                prop="shipPlanType"
              >
                <dict-select
                  v-model="formData.shipPlanType"
                  :selectedLabel.sync="formData.v_shipPlanType"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'shipPlanType' }"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  clearable
                  filterable
                  style="width:100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_shipPlanRange') || '补货范围'"
                prop="shipPlanRange"
              >
                <el-select
                  v-model="formData.shipPlanRange"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  filterable
                  style="width:100%"
                  :disabled="isChange"
                >
                  <el-option
                    :label="$l('form_label_shipPlanRange_a') || '全部店铺'"
                    value="A"
                  >
                  </el-option>
                  <el-option
                    :label="$l('form_label_shipPlanRange_b') || '指定店铺'"
                    value="B"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_beginDate') || '补货填报开始日期'"
                prop="beginDate"
              >
                <el-date-picker
                  v-model="formData.beginDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                  :picker-options="beginDateOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_endDate') || '补货填报截止日期'"
                prop="endDate"
              >
                <el-date-picker
                  v-model="formData.endDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                  style="width: 100%"
                  :picker-options="endDateOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
      <el-col :span="8" v-if="formData.shipPlanRange == 'B'">
        <el-row>
          <div class="side-frame-warning mt-2">
            <el-badge :value="amzStoreCount">
              <span style="font-size: 15px; color: #606266">
                {{ $l('group_tital_shipPlanRange_store') || '补货店铺' }}
              </span>
            </el-badge>
          </div>
          <StoreTable
            ref="storeTable"
            :disabled="disabled || isChange"
            :amazonStoreRegion="formData.amazonStoreRegion"
            :checked-keys="formData.listAmzStoreCode"
            @checkbox-change="storeCheckboxChange"
          />
        </el-row>
      </el-col>
    </el-row>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import StoreTable from '../store-table'
export default {
  mixins: [EditLoading],
  components: { StoreTable },
  props: {
    disabled: { type: Boolean, default: false },
    isChange: { type: Boolean, default: false },
    amzReplenishmentPeriodCode: { type: String, default: '' },
    shipPlanRange: { type: String, default: '' },
  },
  data() {
    return {
      formData: { shipPlanRange: 'A' },
      copyAmzPeriodTitle: '',
      listAmzStore: [],
      shippingDateOptions: this.shippingDateOptionsFun(),
      etaDateOptions: this.etaDateOptionsFunFun(),
      beginDateOptions: this.beginDateOptionsFun(),
      endDateOptions: this.endDateOptionsFun(),
      backDialogVisible: false,
      rules: {
        labelingType: [
          {
            required: false,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        planNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        amazonStoreRegion: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        skuSalesChannel: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        shippingDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        etaDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        shipPlanRange: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        beginDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        endDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],

        shipPlanType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    amzStoreCount() {
      return !this.listAmzStore ? 0 : this.listAmzStore.length
    },
    amzPeriodTitle() {
      const {
        v_amazonStoreRegion,
        v_skuSalesChannel,
        shippingDate,
        etaDate,
        v_shipPlanType,
        v_labelingType,
      } = this.formData
      return [
        v_amazonStoreRegion,
        v_skuSalesChannel,
        (shippingDate || '').replaceAll('-', ''),
        (etaDate || '').replaceAll('-', ''),
        v_shipPlanType,
        v_labelingType,
      ]
        .filter(Boolean)
        .join('-')
    },
  },
  watch: {
    'formData.shipPlanRange': {
      handler(val) {
        this.$emit('update:shipPlanRange', val)
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.amzReplenishmentPeriodCode) return
      this.$api
        .ecomAmzPeriodDetailApi({
          amzReplenishmentPeriodCode: this.amzReplenishmentPeriodCode,
        })
        .then((res) => {
          this.formData = res.body
          this.copyAmzPeriodTitle = this.amzPeriodTitle
        })
    },
    storeCheckboxChange(e) {
      this.listAmzStore = e
      this.formData.listAmzStoreCode = this.listAmzStore.map(
        (item) => item.amzStoreCode
      )
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      const params = { ...this.formData, amzPeriodTitle: this.amzPeriodTitle }

      if (this.loadingOpen()) return

      const checkRes = await this.$api
        .ecomAmzPeriodVerificationApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!checkRes) return
      let confirm = true
      if (checkRes.status === 203) {
        confirm = await this.$confirm(
          `<span style="color:#409EFF;font-weight: bold;width:200px">${
            this.amzPeriodTitle
          }</span>
          <br/>
          <span>${this.$l('tip_plan_already_exists') ||
            '已存在相同补货计划;'}</span>
          <br/>
          ${this.$l('tip_plan_confirm') ||
            '若该计划为上一个计划的补充, 请点击“确认”'}`,
          this.$l('INDEX.tips_modal_tip') || '提示',
          {
            confirmButtonText:
              this.$l('INDEX.product_dialog_btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true,
          }
        )
          .then(() => true)
          .catch(() => false)
        if (!confirm) return
      }
      if (this.loadingOpen()) return
      const res = await this.saveApi(params)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || res.msg,
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    saveApi(params) {
      return this.isChange
        ? this.$api.ecomAmzPeriodChangeApi(params).catch(() => null)
        : this.$api.ecomAmzPeriodSaveApi(params).catch(() => null)
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    changeStore() {
      this.formData.amazonStoreRegion === 'amazonJapan'
        ? (this.rules.labelingType[0].required = true)
        : (this.rules.labelingType[0].required = false)
      this.$refs.form.clearValidate('labelingType')
    },
    shippingDateOptionsFun() {
      const self = this
      return {
        disabledDate(time) {
          const { etaDate, beginDate, endDate } = self.formData
          return (
            (etaDate &&
              time.getTime() > new Date(etaDate).getTime() - 8.64e7) ||
            (beginDate && time.getTime() < new Date(beginDate).getTime()) ||
            (endDate && time.getTime() < new Date(endDate).getTime())
          )
        },
      }
    },
    etaDateOptionsFunFun() {
      const self = this
      return {
        disabledDate(time) {
          const { shippingDate, beginDate, endDate } = self.formData
          return (
            (shippingDate &&
              time.getTime() < new Date(shippingDate).getTime()) ||
            (beginDate && time.getTime() < new Date(beginDate).getTime()) ||
            (endDate && time.getTime() < new Date(endDate).getTime())
          )
        },
      }
    },
    beginDateOptionsFun() {
      const self = this
      return {
        disabledDate(time) {
          const { shippingDate, etaDate, endDate } = self.formData
          return (
            (shippingDate &&
              time.getTime() > new Date(shippingDate).getTime() - 8.64e7) ||
            (etaDate &&
              time.getTime() > new Date(etaDate).getTime() - 8.64e7) ||
            (endDate && time.getTime() > new Date(endDate).getTime())
          )
        },
      }
    },
    endDateOptionsFun() {
      const self = this
      return {
        disabledDate(time) {
          const { shippingDate, etaDate, beginDate } = self.formData
          return (
            (shippingDate &&
              time.getTime() > new Date(shippingDate).getTime() - 8.64e7) ||
            (etaDate &&
              time.getTime() > new Date(etaDate).getTime() - 8.64e7) ||
            (beginDate &&
              time.getTime() < new Date(beginDate).getTime() - 8.64e7)
          )
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
